import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { SwipeListControl } from '../../ui-kit/SwipeListControl/SwipeListControl.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { style } from '../../utils/style.js';
import { ITEMS_GAP } from './itemsGap.js';
import { renderCarouselCards } from './renderCarouselCards.js';
import { VISIBLE_ITEM_COUNT } from './visibleItemCount.js';
export const Carousel = UniBlock(({ className, visibleItemCount = VISIBLE_ITEM_COUNT, noCardBorder, arrowsPadded = true, isGap = true, cardSize = 'normal', isNavButtons = false, ...rest }) => (_jsx(BlockWrapper, { className: style(className), defaultPadding: "p-6xl", ...rest, children: _jsx(SwipeListControl, { className: style('relative max-w-full'), visibleItemCount: visibleItemCount, snapAlign: "snap-start", gap: isGap ? ITEMS_GAP : 0, padding: 0, arrowsPadded: arrowsPadded, navButtons: isNavButtons ? getNavButton(rest?.block?.blocks) : [], hasBlur: true, children: renderCarouselCards({ noCardBorder, cardSize, isNavButtons, ...rest }) }) })), {
    childrenTypes: [
        'CarouselCard',
        'CarouselCatalogCard',
        'CarouselRecommendationCard',
        'CarouselTariffsCard',
        'RichTextBlock',
        'ProductBlock',
    ],
    childSchema: () => ({
        isHighlighting: {
            title: 'Выделить карточку',
            type: 'boolean',
        },
    }),
});
const getNavButton = (blocks) => blocks?.map((_) => {
    const content = _?.content;
    return {
        title: content?.title,
        description: content?.additionalDescription || content?.description,
    };
}) ?? [];
//# sourceMappingURL=Carousel.js.map